var _circle, _circle2, _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.269,
    cy: 11,
    r: 10.5,
    fill: "url(#paint0_linear_649_2789)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_649_2789",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 22
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2693,
    cy: 11,
    r: 10.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_649_2789)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0195,
    y: -1,
    width: 12.75,
    height: 12.75,
    fill: "url(#paint1_linear_649_2789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01929 8C5.01929 6.75736 6.02665 5.75 7.26929 5.75H13.2693C14.5119 5.75 15.5193 6.75736 15.5193 8V17C15.5193 18.2426 14.5119 19.25 13.2693 19.25H5.01929V8Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.26953,
    y: -1,
    width: 12.75,
    height: 12.75,
    fill: "#EB6C4D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.519043,
    y: 4.25,
    width: 13.5,
    height: 13.5,
    rx: 1.5,
    fill: "url(#paint2_linear_649_2789)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2693 9.84286C10.2693 8.225 9.20423 7.25 7.51519 7.25H5.01929V14.75H6.56847V12.4679H7.45064C9.03209 12.4679 10.2693 11.5679 10.2693 9.84286ZM8.69859 9.875C8.69859 10.6036 8.23599 11.075 7.48291 11.075H6.56847V8.65357H7.47216C8.22523 8.65357 8.69859 9.05 8.69859 9.875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_2789",
    x1: 2.76904,
    y1: 12.4483,
    x2: 23.769,
    y2: 12.4483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A73A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_649_2789",
    x1: 24.1445,
    y1: 6.5,
    x2: 14.0195,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1876D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_649_2789",
    x1: 0.519043,
    y1: 11.931,
    x2: 14.019,
    y2: 11.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A73A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75936"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPpt);
export default __webpack_public_path__ + "static/media/IconPPT.052f67a144f653a15e335f5ce822ef37.svg";
export { ForwardRef as ReactComponent };